export enum TextWeight {
  REGULAR = 'regular-weight',
  MULTI = 'multi-weight',
  BOLD = 'bold',
}
